import { ChevronDownMedium as IconComponent } from '@adobe/react-spectrum-ui/dist/ChevronDownMedium.js';
import { UIIcon } from '@adobe/react-spectrum/private/icon/UIIcon';
import React from 'react';
export default function ChevronDownMedium(props) {
  return /*#__PURE__*/React.createElement(UIIcon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}